import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import 'firebase/analytics'
import 'firebase/storage'
import * as firebaseui from 'firebaseui'
import 'firebaseui/dist/firebaseui.css'

declare var process: any

const firebaseApp = firebase.initializeApp({
  apiKey: process.env.VUE_APP_APIKEY,
  authDomain: process.env.VUE_APP_AUTHDOMAIN,
  databaseURL: process.env.VUE_APP_DATABASEURL,
  projectId: process.env.VUE_APP_PROJECTID,
  storageBucket: process.env.VUE_APP_STORAGEBUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGINGSENDERID,
  appId: process.env.VUE_APP_APPID,
  measurementId: process.env.VUE_APP_MEASUREMENTID,
})

export const auth = firebase.auth(firebaseApp)

export const observeUser = (observer: (user: firebase.User | null) => void) =>
  auth.onAuthStateChanged(observer)
export const getUser = () => auth.currentUser

export const getUserId = async () => {
  const user = auth.currentUser
  if (user) {
    return user.uid
  }

  const credential = await auth.signInAnonymously()
  const uid = credential.user?.uid
  if (!uid) {
    throw new Error(`[Firebase] Failed to signin anonymously`)
  }

  return uid
}

export const createAnonymousUser = async () => {
  const credential = await auth.signInAnonymously()
  return credential.user
}

const ui = new firebaseui.auth.AuthUI(auth)
export const renderAuthUI = (element: Element) => {
  ui.start(element, {
    signInOptions: [
      {
        provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
        requireDisplayName: false,
      },
    ],
    credentialHelper: firebaseui.auth.CredentialHelper.NONE,
    callbacks: {
      signInSuccessWithAuthResult: function() {
        return false
      },
    },
  })
}

export const signOut = async () => await auth.signOut()

export const db = firebaseApp.database()
export const storage = firebaseApp.storage()
export const analytics = firebaseApp.analytics()

export const exists = async (ref: firebase.database.Reference) =>
  new Promise(resolve => {
    ref.once('value', snapshot => resolve(snapshot.exists()))
  })

export const serverNow = firebase.database.ServerValue.TIMESTAMP

export default firebaseApp
